<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">

      <!-- HEADER -->
      <div class="header-block">
        <div class="header-title">
          <!-- <app-breadcrumb></app-breadcrumb> -->
          <h4>Live Users Tracking</h4>
        </div>
        <div class="add-block">
          <div class="filter-icon" style="cursor: pointer;">
            <i class="bi bi-arrow-clockwise" (click)="getUsers()" title="Refresh"></i>
          </div>
        </div>
      </div>

      <!-- MAIN CONTENT -->
      <div class="map-content-wrapper">
        <!-- MAP -->
        <div class="map-panel">
          <div id="live-tracking-map"></div>
        </div>

        <!-- LIST SIDEBAR -->
        <div class="list-panel">
          <!-- List Heading -->
          <div class="list-heading" style="gap: 10px;">
            <input type="text" class="form-control" style="margin: 0;" placeholder="Search users..."
              [(ngModel)]="searchQuery">
            <div class="heading-actions">
              <span class="asset-count">{{filteredUsers.length}}</span>
            </div>
          </div>

          <!-- Users List -->
          <div class="location-list">
            <div class="empty-state" *ngIf="filteredUsers.length === 0">
              <p>No users found</p>
            </div>

            <div class="location-card" *ngFor="let user of filteredUsers; let i = index"
              [class.active]="selectedUser === user" (click)="selectUser(user, i)">

              <div class="location-info">
                <div class="location-name">
                  {{ user.userName}}
                </div>
                <div class="location-meta">
                  {{ user.userMobileNo || 'No mobile provided' }}
                </div>
              </div>

              <div class="asset-icons-container">
                <div title="Online">
                  <span
                    style="display:inline-block; width:10px; height:10px; border-radius:50%; background-color:#4DF02D; box-shadow:0 0 5px rgba(77,240,45,0.5);"></span>
                </div>
              </div>

              <div class="action-icon ms-2" *ngIf="selectedUser === user">
                <i class="bi bi-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>